import type { ConversationMessage } from "@dreamverse/contracts";
import { apiRequest } from "./api-client";

export interface TodayChannelEncounterThread {
  id: string;
  scopeLabel: string;
  startedAt: string;
  latestAt: string;
  preview: string;
  messages: readonly ConversationMessage[];
}

export interface TodayChannelEncounterPlatform {
  providerKey: string;
  platformLabel: string;
  messageCount: number;
  latestAt: string;
  hasEarlier: boolean;
  threads: readonly TodayChannelEncounterThread[];
}

export interface TodayChannelEncounters {
  date: string;
  platforms: readonly TodayChannelEncounterPlatform[];
}

export function fetchTodayChannelEncounters(signal?: AbortSignal) {
  return apiRequest<TodayChannelEncounters>("/api/v1/app/channel-encounters/today", {
    ...(signal ? { signal } : {}),
  });
}
